import React from 'react';

import { Text } from '@reckon-web/text';

interface IActivityPropertyBoolean {
  value?: string | null;
}

// ActivityProperty Boolean = 4
export const ActivityPropertyBoolean = ({
  value,
}: IActivityPropertyBoolean) => {
  // no idea what will be in the db really, so let's be a little conservative at what we consider true to be
  const trueValues = new Set(['1', 'true', 'yes']);

  const formattedValue = () => {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const parsedVal = trueValues.has(value.toLowerCase());
    return parsedVal ? 'True' : 'False';
  };

  return (
    <Text size="small" weight="semibold">
      {formattedValue()}
    </Text>
  );
};
